import { http } from '../helpers/http'

const findSimplified = (datetimeFrom, datetimeTo) => {
  let url = '/logs/users'
  url += `?startDate=${datetimeFrom}`
  url += `&endDate=${datetimeTo}`

  return http.get(url)
}

const findDetailed = (datetimeFrom, datetimeTo) => {
  let url = '/logs/items'
  url += `?startDate=${datetimeFrom}`
  url += `&endDate=${datetimeTo}`

  return http.get(url)
}

export const logService = {
  findSimplified,
  findDetailed
}
